import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "breadcrumb" }
const _hoisted_2 = {
  key: 0,
  class: "breadcrumb-actions"
}
const _hoisted_3 = {
  key: 0,
  class: "msg"
}
const _hoisted_4 = {
  key: 1,
  class: "msg error"
}
const _hoisted_5 = {
  key: 2,
  class: "tbl-wrap"
}
const _hoisted_6 = { class: "tbl" }
const _hoisted_7 = { class: "mono" }
const _hoisted_8 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_9 = { class: "actions" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 1,
  class: "archived-user-icon",
  title: "Utente archiviato"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "account-cards" }
const _hoisted_15 = { class: "account-card" }
const _hoisted_16 = { class: "field-group" }
const _hoisted_17 = { class: "input-wrap" }
const _hoisted_18 = ["type"]
const _hoisted_19 = {
  key: 0,
  class: "err"
}
const _hoisted_20 = { class: "field-group" }
const _hoisted_21 = { class: "input-wrap" }
const _hoisted_22 = ["type"]
const _hoisted_23 = { class: "field-group" }
const _hoisted_24 = { class: "input-wrap" }
const _hoisted_25 = ["type"]
const _hoisted_26 = {
  key: 0,
  class: "err"
}
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { class: "account-card danger" }
const _hoisted_29 = {
  key: 3,
  class: "modal-mask"
}
const _hoisted_30 = { class: "modal" }
const _hoisted_31 = { class: "modal-actions" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  key: 4,
  class: "modal-mask"
}
const _hoisted_35 = { class: "modal" }
const _hoisted_36 = { class: "modal-input-wrap" }
const _hoisted_37 = ["type"]
const _hoisted_38 = { class: "modal-actions" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  key: 5,
  class: "modal-mask"
}
const _hoisted_42 = { class: "modal" }
const _hoisted_43 = { class: "modal-actions" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = ["disabled"]
const _hoisted_46 = {
  key: 6,
  class: "modal-mask"
}
const _hoisted_47 = { class: "modal" }
const _hoisted_48 = { class: "modal-actions" }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = ["disabled"]
const _hoisted_51 = {
  key: 7,
  class: "modal-mask"
}
const _hoisted_52 = { class: "modal" }
const _hoisted_53 = { class: "modal-actions" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = ["disabled"]

import axios from "@/axiosInstance";
	import router, { setAuth } from "@/router";
	import dayjs from "dayjs";
	import { Archive as ArchiveIcon, ArchiveRestore as ArchiveRestoreIcon, Eye as EyeIcon, EyeOff as EyeOffIcon, Share2 as ShareIcon, Trash as TrashIcon } from "lucide-vue-next";
	import type { Ref } from "vue";
	import { computed, inject, nextTick, onMounted, ref } from "vue";
	import { useToast } from "vue-toast-notification";
	import DeviceShareModal from "./DeviceShareModal.vue";
	import NotificationBell from "./NotificationBell.vue";

	
export default /*@__PURE__*/_defineComponent({
  __name: 'Account',
  setup(__props) {

	const isDesktop = inject<Ref<boolean>>("isDesktop")!;
	const isSidebarOpen = inject<Ref<boolean>>("isSidebarOpen")!;

	const showCrumbBell = computed(() => !isDesktop.value || (isDesktop.value && !isSidebarOpen.value));

	/* ─── stato utente ─── */
	const me = ref<any>({});
	const isAdmin = computed(() => me.value.is_admin);

	/* ─── lista admin ─── */
	const usersList = ref<any[]>([]);
	const loading = ref(true);
	const error = ref<string | null>(null);

	/* ─── toast ─── */
	const toast = useToast();

	/* ─── cambio password ─── */
	const oldPwd = ref("");
	const newPwd = ref("");
	const newPwd2 = ref("");
	const pwdLoading = ref(false);

	const showOld = ref(false); // 👁️
	const showNew = ref(false);
	const showNew2 = ref(false);

	const oldPwdValid = ref<null | boolean>(null); // null = non controllata
	const checkingOldPwd = ref(false);
	let timer: ReturnType<typeof setTimeout> | null = null;

	const newPwdsMatch = computed(() => newPwd.value && newPwd2.value && newPwd.value === newPwd2.value);

	/* ─── aggiunta admin ─── */
	const showAddModal = ref(false);
	const newAdminEmail = ref("");
	const addLoading = ref(false);

	/* ─── aggiunta utente ─── */
	const showAddUserModal = ref(false);
	const newUserEmail = ref("");
	const newUserPassword = ref(""); // opzionale
	const addUserLoading = ref(false);
	const showUserPwd = ref(false);

	/* ─── rimozione admin (solo per admin) ─── */
	const showRemoveAdminModal = ref(false);
	const showRestoreAdminModal = ref(false);
	const selectedAdmin = ref<any | null>(null);
	const removeAdminLoading = ref(false);


	/* ─── condivisione device (solo per admin) ─── */
	const showShareModal = ref(false);
	const selectedUserForShare = ref<any | null>(null);
	const sharedDevicesMap = ref<Record<number, number[]>>({}); // userId -> deviceIds[]

	/* ─── elimina account ─── */
	const showDeleteModal = ref(false);
	const delPwd = ref("");
	const delLoading = ref(false);

	onMounted(fetchData);

	async function fetchData() {
		loading.value = true;
		try {
			// 1. chiedo solo /auth/me
			const { data: user } = await axios.get("/auth/me");
			me.value = user;

			// 2. se è admin, recupero la lista; altrimenti la lascio vuota
			if (me.value.is_admin) {
				const { data: users } = await axios.get("/auth/get-users");
				usersList.value = users;

				// 3. Per ogni utente non-admin, carico i device condivisi
				await loadSharedDevicesForUsers();
			} else {
				usersList.value = []; // niente tabella per i non-admin
			}
		} catch (e: any) {
			// mostro l'errore solo se l'utente è admin (→ errore reale)
			if (me.value.is_admin) {
				error.value = e.response?.data?.details || "Errore caricamento";
			} else {
				error.value = null; // silenzio per i non-admin
			}
		} finally {
			loading.value = false;
		}
	}

	// Carica i device condivisi per tutti gli utenti
	async function loadSharedDevicesForUsers() {
		const nonAdminUsers = usersList.value.filter((u) => !u.is_admin);

		for (const user of nonAdminUsers) {
			try {
				const { data } = await axios.get(`/auth/${user.id}/shared-devices`, { withCredentials: true });
				// Assumiamo che data sia un array di ID o un oggetto { devices: [...] }
				const deviceIds = Array.isArray(data) ? data.map((x: any) => (typeof x === "object" ? x.id : x)) : data.devices?.map((x: any) => (typeof x === "object" ? x.id : x)) || [];

				sharedDevicesMap.value[user.id] = deviceIds;
			} catch (e) {
				// Se l'endpoint non esiste ancora o c'è un errore, ignora
				sharedDevicesMap.value[user.id] = [];
			}
		}
	}

	// Funzione helper per ottenere il conteggio
	function getSharedDevicesCount(user: any): number {
		return sharedDevicesMap.value[user.id]?.length || 0;
	}

	// Verifica vecchia password al blur (con debounce 400 ms)
	async function verifyOldPassword() {
		if (timer) clearTimeout(timer);
		timer = setTimeout(async () => {
			if (!oldPwd.value) return (oldPwdValid.value = null);

			try {
				checkingOldPwd.value = true;
				const { data } = await axios.post("/auth/verify-password", {
					password: oldPwd.value,
				});
				oldPwdValid.value = data.ok; // true / false
			} catch {
				oldPwdValid.value = false;
			} finally {
				checkingOldPwd.value = false;
			}
		}, 400);
	}

	/* ─── cambio password ─── */
	async function changePassword() {
		if (newPwd.value !== newPwd2.value) {
			toast.error("Le nuove password non coincidono", {
				position: "top-right",
				duration: 2500,
			});
			return;
		}
		if (!oldPwd.value) {
			toast.info("La vecchia password è necessaria per effettuare la sua verifica", {
				position: "top-right",
				duration: 2500,
			});
			return;
		} else if (!newPwd.value) {
			toast.info("Il campo nuova password è necessario", {
				position: "top-right",
				duration: 2500,
			});
			return;
		}

		try {
			pwdLoading.value = true;
			const response = await axios.patch("/auth/change-password", {
				oldPassword: oldPwd.value,
				newPassword: newPwd.value,
			});

			toast.success(response.data || "Password aggiornata con successo ✔︎", {
				position: "top-right",
				duration: 2000,
			});
			oldPwd.value = newPwd.value = newPwd2.value = "";

			// logout & redirect
			setTimeout(() => {
				setAuth(false);
				router.push("/auth");
			}, 2000);
		} catch (e: any) {
			toast.error(e.response?.data?.details || "Errore cambio password", {
				position: "top-right",
				duration: 2500,
			});
		} finally {
			pwdLoading.value = false;
		}
	}

	async function confirmAddUser() {
		if (!isAdmin.value) return;

		try {
			addUserLoading.value = true;
			const payload = {
				email: newUserEmail.value,
				role: "user",
				password: newUserPassword.value?.trim() || "password",
			};
			const { data } = await axios.post("/auth/register-user", payload);

			// aggiorno la lista in tabella
			usersList.value.push(data.user);

			toast.success("Nuovo utente aggiunto", {
				position: "top-right",
				duration: 2500,
			});

			closeAddUserModal();
		} catch (e: any) {
			toast.error(e.response?.data?.details || "Errore aggiunta utente", {
				duration: 2500,
			});
		} finally {
			addUserLoading.value = false;
		}
	}
	function closeAddUserModal() {
		showAddUserModal.value = false;
		newUserEmail.value = "";
		newUserPassword.value = "";
		showUserPwd.value = false;
	}

	/* ─── aggiungi admin ─── */
	async function confirmAddAdmin() {
		try {
			addLoading.value = true;
			const payload = {
				email: newAdminEmail.value,
				role: "admin",
				password: "password",
			};
			const { data } = await axios.post("/auth/register-user", payload);
			usersList.value.push(data.user);
			toast.success("Nuovo admin aggiunto", {
				position: "top-right",
				duration: 2500,
			});
			closeAddModal();
		} catch (e: any) {
			// console.error(e);
			toast.error(e.response?.data?.details || "Errore aggiunta admin", {
				duration: 2500,
			});
		} finally {
			addLoading.value = false;
		}
	}
	function closeAddModal() {
		showAddModal.value = false;
		newAdminEmail.value = "";
	}

	/* ─── rimuovi admin (solo per admin) ─── */
	function openRemoveAdminModal(adm: any) {
		if (!isAdmin.value) return;
		selectedAdmin.value = adm;
		showRemoveAdminModal.value = true;
	}

	/* ─── ripristina admin (solo per admin) ─── */
	function openRestoreAdminModal(adm: any) {
		if (!isAdmin.value) return;
		selectedAdmin.value = adm;
		//   console.log("selectedAdmin.value", selectedAdmin.value);
		showRestoreAdminModal.value = true;
	}

	async function removeAdmin() {
		const adm = selectedAdmin.value;
		if (!adm) return;

		if (!isAdmin.value) return;
		if (adm.id === me.value.id) {
			toast.error("Non puoi rimuovere te stesso", { duration: 2500 });
			return;
		}

		removeAdminLoading.value = true;
		try {
			await axios.post(`/auth/${adm.id}/archive-admin`);
			// usersList.value = usersList.value.filter((a) => a.id !== adm.id);
			toast.success(`${adm.is_admin ? "Admin" : "Utente"} ${adm.email} rimosso`, {
				position: "top-right",
				duration: 2000,
			});
			adm.is_archived = true;
			closeRemoveAdminModal();
		} catch (e: any) {
			closeRemoveAdminModal();
			console.error(e);
			toast.error(e.response?.data?.details || "Errore rimozione", {
				position: "top-right",
				duration: 2500,
			});
		}
	}

	async function restoreAdmin() {
		const adm = selectedAdmin.value;
		if (!adm) return;

		if (!isAdmin.value) return;
		if (adm.id === me.value.id) {
			toast.error("Non puoi ripristinare te stesso", { duration: 2500 });
			return;
		}

		removeAdminLoading.value = true;
		try {
			const { data } = await axios.post(`/auth/${adm.id}/restore`);
			// usersList.value = usersList.value.filter((a) => a.id !== adm.id);
			toast.success(`${adm.is_admin ? "Admin" : "Utente"} ${adm.email} ripristinato`, {
				position: "top-right",
				duration: 2000,
			});
			adm.is_archived = false;
			closeRestoreAdminModal();
		} catch (e: any) {
			closeRestoreAdminModal();
			console.error(e);
			toast.error(e.response?.data?.details || "Errore ripristino", {
				position: "top-right",
				duration: 2500,
			});
		}
	}

	function closeRemoveAdminModal() {
		showRemoveAdminModal.value = false;
		selectedAdmin.value = null;
		removeAdminLoading.value = false;
	}

	function closeRestoreAdminModal() {
		showRestoreAdminModal.value = false;
		selectedAdmin.value = null;
		removeAdminLoading.value = false;
	}

	/* ─── condivisione device ─── */
	function openShareModal(user: any) {
		selectedUserForShare.value = user;
		showShareModal.value = true;
	}
	function closeShareModal() {
		showShareModal.value = false;
		selectedUserForShare.value = null;
		// Ricarica i device condivisi per aggiornare il count
		if (isAdmin.value) {
			loadSharedDevicesForUsers();
		}
	}

	/* ─── elimina account ─── */
	async function confirmDelete() {
		try {
			delLoading.value = true;
			const response = await axios.post(`/auth/delete-account`, { password: delPwd.value }, { withCredentials: true });
			toast.success(response.data || `L'account è stato programmato per l'eliminazione (entro 7 giorni).`, {
				position: "top-right",
				duration: 2000,
			});

			closeDeleteModal();

			// logout e redirect a login
			setTimeout(() => {
				setAuth(false);
				router.push("/auth");
			}, 2000);
		} catch (e: any) {
			toast.error(e.response?.data?.message || "Password errata", {
				position: "top-right",
				duration: 2500,
			});
		} finally {
			delLoading.value = false;
		}
	}

	function closeDeleteModal() {
		showDeleteModal.value = false;
		delPwd.value = "";
	}

	/* ─── util ─── */
	function formatDate(iso: string) {
		return dayjs(iso).isValid() ? dayjs(iso).format("DD/MM/YYYY HH:mm") : "—";
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("span", null, "Account " + _toDisplayString(isAdmin.value ? "➠ Gestione degli utenti" : ""), 1),
      (isAdmin.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "btn-new",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showAddUserModal.value = true))
            }, " + Nuovo utente "),
            _createElementVNode("button", {
              class: "btn-new",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showAddModal.value = true))
            }, " + Nuovo admin "),
            (showCrumbBell.value)
              ? (_openBlock(), _createBlock(NotificationBell, {
                  key: 0,
                  placement: "header"
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Caricamento… "))
      : (error.value && isAdmin.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(error.value), 1))
        : _createCommentVNode("", true),
    (isAdmin.value && usersList.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _cache[16] || (_cache[16] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "ID"),
                _createElementVNode("th", null, "Email"),
                _createElementVNode("th", null, "Ruolo"),
                _createElementVNode("th", null, "Device condivisi"),
                _createElementVNode("th", null, "Creato il"),
                _createElementVNode("th")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usersList.value, (adm, i) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: adm.id,
                  class: _normalizeClass(i % 2 && 'alt')
                }, [
                  _createElementVNode("td", _hoisted_7, _toDisplayString(adm.id), 1),
                  _createElementVNode("td", null, _toDisplayString(adm.email), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["account-badge", adm.is_admin ? 'admin' : 'user'])
                    }, _toDisplayString(adm.is_admin ? "Admin" : "User"), 3)
                  ]),
                  _createElementVNode("td", null, [
                    (!adm.is_admin)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(["shared-count-badge", { 'has-devices': getSharedDevicesCount(adm) > 0 }])
                        }, _toDisplayString(getSharedDevicesCount(adm)) + " device" + _toDisplayString(getSharedDevicesCount(adm) !== 1 ? 's' : ''), 3))
                      : (_openBlock(), _createElementBlock("span", _hoisted_8, "—"))
                  ]),
                  _createElementVNode("td", null, _toDisplayString(formatDate(adm.createdAt || adm.created_at)), 1),
                  _createElementVNode("td", _hoisted_9, [
                    (isAdmin.value && !adm.is_admin)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          title: "Condividi devices",
                          class: "share-btn",
                          onClick: ($event: any) => (openShareModal(adm))
                        }, [
                          _createVNode(_unref(ShareIcon))
                        ], 8, _hoisted_10))
                      : _createCommentVNode("", true),
                    (adm.id !== me.value.id && isAdmin.value && adm.is_archived)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                          _createVNode(_unref(ArchiveIcon))
                        ]))
                      : _createCommentVNode("", true),
                    (adm.id !== me.value.id && isAdmin.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          title: "Rimuovi utente",
                          onClick: ($event: any) => (openRemoveAdminModal(adm))
                        }, [
                          _createVNode(_unref(TrashIcon))
                        ], 8, _hoisted_12))
                      : _createCommentVNode("", true),
                    (adm.id !== me.value.id && isAdmin.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 3,
                          class: "restore-icon",
                          title: "Ripristina utente",
                          onClick: ($event: any) => (openRestoreAdminModal(adm))
                        }, [
                          _createVNode(_unref(ArchiveRestoreIcon))
                        ], 8, _hoisted_13))
                      : _createCommentVNode("", true)
                  ])
                ], 2))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _cache[20] || (_cache[20] = _createElementVNode("h3", null, "Cambia password", -1)),
        _createElementVNode("form", {
          class: "form",
          onSubmit: _withModifiers(changePassword, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_16, [
            _cache[17] || (_cache[17] = _createElementVNode("label", null, "Vecchia password", -1)),
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((oldPwd).value = $event)),
                type: showOld.value ? 'text' : 'password',
                required: "",
                onInput: verifyOldPassword,
                onBlur: verifyOldPassword,
                class: _normalizeClass({ invalid: oldPwdValid.value === false })
              }, null, 42, _hoisted_18), [
                [_vModelDynamic, oldPwd.value]
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "eye",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (showOld.value = !showOld.value))
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(showOld.value ? _unref(EyeOffIcon) : _unref(EyeIcon))))
              ])
            ]),
            (oldPwdValid.value === false)
              ? (_openBlock(), _createElementBlock("p", _hoisted_19, " * Password non corretta "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[18] || (_cache[18] = _createElementVNode("label", null, "Nuova password", -1)),
            _createElementVNode("div", _hoisted_21, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newPwd).value = $event)),
                type: showNew.value ? 'text' : 'password',
                required: ""
              }, null, 8, _hoisted_22), [
                [_vModelDynamic, newPwd.value]
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "eye",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (showNew.value = !showNew.value))
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(showNew.value ? _unref(EyeOffIcon) : _unref(EyeIcon))))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _cache[19] || (_cache[19] = _createElementVNode("label", null, "Conferma nuova password", -1)),
            _createElementVNode("div", _hoisted_24, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((newPwd2).value = $event)),
                type: showNew2.value ? 'text' : 'password',
                required: "",
                class: _normalizeClass({ invalid: newPwd2.value && !newPwdsMatch.value })
              }, null, 10, _hoisted_25), [
                [_vModelDynamic, newPwd2.value]
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "eye",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (showNew2.value = !showNew2.value))
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(showNew2.value ? _unref(EyeOffIcon) : _unref(EyeIcon))))
              ])
            ]),
            (newPwd2.value && !newPwdsMatch.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_26, " * Le nuove password non coincidono "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            class: "btn-primary",
            disabled: pwdLoading.value || !oldPwd.value || !newPwdsMatch.value || oldPwdValid.value === false || checkingOldPwd.value
          }, " Aggiorna ", 8, _hoisted_27)
        ], 32)
      ]),
      _createElementVNode("div", _hoisted_28, [
        _cache[21] || (_cache[21] = _createElementVNode("h3", null, "Elimina account", -1)),
        _cache[22] || (_cache[22] = _createElementVNode("p", null, [
          _createTextVNode("Operazione "),
          _createElementVNode("strong", null, "irreversibile"),
          _createTextVNode(". Tutti i tuoi dati verranno rimossi e il tuo account eliminato entro 7 giorni.")
        ], -1)),
        _createElementVNode("button", {
          class: "btn-danger",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (showDeleteModal.value = true))
        }, " Cancella account ")
      ])
    ]),
    (showAddModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _cache[23] || (_cache[23] = _createElementVNode("h3", null, "Nuovo amministratore", -1)),
            _cache[24] || (_cache[24] = _createElementVNode("label", { class: "modal-label" }, "Email", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((newAdminEmail).value = $event)),
              class: "modal-input",
              type: "email",
              placeholder: "email@dominio.com"
            }, null, 512), [
              [
                _vModelText,
                newAdminEmail.value,
                void 0,
                { trim: true }
              ]
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("button", {
                disabled: addLoading.value || !newAdminEmail.value,
                onClick: confirmAddAdmin
              }, " OK ", 8, _hoisted_32),
              _createElementVNode("button", {
                disabled: addLoading.value,
                onClick: closeAddModal
              }, " Annulla ", 8, _hoisted_33)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showAddUserModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _cache[25] || (_cache[25] = _createElementVNode("h3", null, "Nuovo utente", -1)),
            _cache[26] || (_cache[26] = _createElementVNode("label", { class: "modal-label" }, "Email", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((newUserEmail).value = $event)),
              class: "modal-input",
              type: "email",
              placeholder: "email@dominio.com"
            }, null, 512), [
              [
                _vModelText,
                newUserEmail.value,
                void 0,
                { trim: true }
              ]
            ]),
            _cache[27] || (_cache[27] = _createElementVNode("label", {
              class: "modal-label",
              style: {"margin-top":"12px"}
            }, "Password (opzionale)", -1)),
            _createElementVNode("div", _hoisted_36, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((newUserPassword).value = $event)),
                type: showUserPwd.value ? 'text' : 'password',
                class: "modal-input",
                placeholder: "password (default: 'password')"
              }, null, 8, _hoisted_37), [
                [_vModelDynamic, newUserPassword.value]
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "eye",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (showUserPwd.value = !showUserPwd.value))
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(showUserPwd.value ? _unref(EyeOffIcon) : _unref(EyeIcon))))
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("button", {
                disabled: addUserLoading.value || !newUserEmail.value,
                onClick: confirmAddUser
              }, " OK ", 8, _hoisted_39),
              _createElementVNode("button", {
                disabled: addUserLoading.value,
                onClick: closeAddUserModal
              }, " Annulla ", 8, _hoisted_40)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showRemoveAdminModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("h3", null, "Rimuovi " + _toDisplayString(selectedAdmin.value?.is_admin ? "Amministratore" : "Utente"), 1),
            _createElementVNode("p", null, [
              _cache[28] || (_cache[28] = _createTextVNode(" Sei sicuro di voler rimuovere ", -1)),
              _createElementVNode("strong", null, _toDisplayString(selectedAdmin.value?.email), 1),
              _cache[29] || (_cache[29] = _createTextVNode("? ", -1))
            ]),
            _cache[30] || (_cache[30] = _createElementVNode("p", null, "Questa azione non può essere annullata.", -1)),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("button", {
                disabled: removeAdminLoading.value,
                onClick: removeAdmin
              }, " Rimuovi ", 8, _hoisted_44),
              _createElementVNode("button", {
                disabled: removeAdminLoading.value,
                onClick: _cache[13] || (_cache[13] = ($event: any) => (showRemoveAdminModal.value = false))
              }, " Annulla ", 8, _hoisted_45)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showRestoreAdminModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("h3", null, "Ripristina " + _toDisplayString(selectedAdmin.value?.is_admin ? "Amministratore" : "Utente"), 1),
            _createElementVNode("p", null, [
              _cache[31] || (_cache[31] = _createTextVNode(" Sei sicuro di voler ripristinare ", -1)),
              _createElementVNode("strong", null, _toDisplayString(selectedAdmin.value?.email), 1),
              _cache[32] || (_cache[32] = _createTextVNode("? ", -1))
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("button", {
                disabled: removeAdminLoading.value,
                onClick: restoreAdmin
              }, " Ripristina ", 8, _hoisted_49),
              _createElementVNode("button", {
                disabled: removeAdminLoading.value,
                onClick: _cache[14] || (_cache[14] = ($event: any) => (showRestoreAdminModal.value = false))
              }, " Annulla ", 8, _hoisted_50)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showDeleteModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _cache[33] || (_cache[33] = _createElementVNode("h3", null, "Conferma eliminazione", -1)),
            _cache[34] || (_cache[34] = _createElementVNode("p", null, "Inserisci la tua password per confermare:", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((delPwd).value = $event)),
              class: "modal-input",
              type: "password",
              placeholder: "Password"
            }, null, 512), [
              [_vModelText, delPwd.value]
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("button", {
                disabled: delLoading.value || !delPwd.value,
                onClick: confirmDelete
              }, " Elimina ", 8, _hoisted_54),
              _createElementVNode("button", {
                disabled: delLoading.value,
                onClick: closeDeleteModal
              }, " Annulla ", 8, _hoisted_55)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showShareModal.value)
      ? (_openBlock(), _createBlock(DeviceShareModal, {
          key: 8,
          user: selectedUserForShare.value,
          onClose: closeShareModal
        }, null, 8, ["user"]))
      : _createCommentVNode("", true)
  ]))
}
}

})